import { MainLogo } from './mainLogo';
import SocialLinks from './SocialLinks';
import { useMediaQuery, BREAKPOINTS } from "../hooks/useMediaQuery";

// 사업자 정보. 캠퍼스마다 사업자가 따로 등록돼 있어 둘 다 표기한다.
// 데스크탑/모바일이 따로 하드코딩돼 있어 표기가 서로 달랐던 적이 있어, 한 곳에서 관리한다.
const BUSINESSES = [
  {
    name: '아나톨레교육원',
    campus: '월산점',
    owner: '김주선',
    bizNo: '509-87-02068',
    address: '경기도 남양주시 경춘로2290번길 5, 102호, 201호, 202호 일부',
    phone: '031-559-9270',
  },
  {
    name: '호평아나톨레어학원',
    campus: '호평점',
    owner: '황인경',
    bizNo: '675-92-02507',
    address: '경기도 남양주시 백봉로 32, B동 상가 202호, 202A호 일부',
    phone: '031-594-9270',
  },
];


const BusinessInfo = ({ compact }) => {
  const textClass = compact
    ? 'kr-font text-label-medium font-semibold text-primary'
    : 'kr-font text-title-medium text-primary';

  return (
    <div className={compact ? 'flex flex-col gap-[14px] py-[30px]' : 'flex flex-col gap-[14px] pt-[50px]'}>
      {BUSINESSES.map((b) => (
        <div key={b.bizNo} className={textClass}>
          <p>
            상호: {b.name} ({b.campus})
            {compact ? <br /> : '  |  '}
            대표자: {b.owner}
            {compact ? <br /> : '  |  '}
            사업자 등록번호: {b.bizNo}
          </p>
          <p className={compact ? '' : 'pt-1'}>
            대표전화: {b.phone}
            {compact ? <br /> : '  |  '}
            사업장소재지: {b.address}
          </p>
        </div>
      ))}
    </div>
  );
};

export default function Footer() {
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE);
  const isTablet = useMediaQuery(BREAKPOINTS.TABLET);
  return (
    <footer className="text-primary px-[16px] tablet:px-[35px]">
      <div className="max-w-[1480px] mx-auto tablet:py-20 py-10">
        <div className="flex tablet:flex-row flex-col tablet:justify-between justify-center items-center">
          <div className="tablet:self-auto self-start">
            <MainLogo className="w-[230px] tablet:w-[260px]" />
            <BusinessInfo compact={isMobile || isTablet} />
          </div>
          <SocialLinks className="self-end tablet:mt-[20px] mt-0 tablet:mt-0" />
        </div>

        <div className="border-t border-primary pt-4 text-end mt-[45px]">
          <p className="text-[12px] text-primary font-poppins">
            © 2025 Anatole All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
} 